<template>
  <esg-base-dashboard>
    <!-- 전사 Scope별 온실가스 배출량과 최근 3개년 Scope별 배출량 -->
    <b-row>
      <!-- 전사 Scope별 온실가스 배출량 -->
      <b-col lg="6">
        <esg-base-dashboard-card title="온실가스 배출량"
                                 :subtitle="`(Scope 단위 - ${currentYear}년)`">
          <firmwide-emission-by-scope legend="bottom"/>
        </esg-base-dashboard-card>
      </b-col>
      <!-- 전사 Scope별 온실가스 배출량 -->

      <!-- 최근 3개년 Scope별 배출량 -->
      <b-col lg="6">
        <esg-base-dashboard-card title="온실가스 배출량 추이"
                                 subtitle="(Scope 단위 - 과거 3개년)">
          <emission-by-scope-for-three-years legend="bottom"/>
        </esg-base-dashboard-card>
      </b-col>
      <!-- /최근 3개년 Scope별 배출량 -->
    </b-row>
    <!-- /전사 Scope별 온실가스 배출량과 최근 3개년 Scope별 배출량 -->

    <!-- Scope 1, 2, 3 최근 3개년 연도별 배출량 -->
    <b-row>
      <b-col>
        <esg-base-dashboard-card title="온실가스 배출량 추이 상세"
                                 subtitle="(Scope 단위 - 과거 3개년)">
          <b-row>
            <template v-for="scope in [1, 2, 3]">
              <b-col lg="4"
                     :key="scope">
                <esg-base-dashboard-card :title="`Scope ${scope} 온실가스 배출량`">
                  <single-scope-emission-for-three-years :scope="scope"
                                                         :color="colors[scope - 1]"/>
                </esg-base-dashboard-card>
              </b-col>
            </template>
          </b-row>
        </esg-base-dashboard-card>
      </b-col>
    </b-row>
    <!-- /Scope 1, 2, 3 최근 3개년 연도별 배출량 -->

    <!-- Scope 1, 2 월별 배출량 -->
    <template v-for="scope in [1, 2]">
      <b-row :key="scope">
        <b-col>
          <esg-base-dashboard-card :title="`Scope${scope} 온실가스 배출량 추이`"
                                   :subtitle="`(전사 - ${currentYear}년 - 월별)`">
            <esg-base-chart>
              <single-scope-monthly-emission :scope="scope"
                                             :color="colors[scope - 1]"/>
            </esg-base-chart>
          </esg-base-dashboard-card>
        </b-col>
      </b-row>
    </template>
    <!-- /Scope 1, 2 월별 배출량 -->

    <!-- Scope 3 분기별 배출량 -->
    <b-row>
      <b-col>
        <esg-base-dashboard-card :title="`Scope3 온실가스 배출량 추이`"
                                 :subtitle="`(전사 - ${currentYear}년 - 분기별)`">
          <esg-base-chart>
            <single-scope-quarterly-emission :color="colors[2]"
                                             :scope="3"/>
          </esg-base-chart>
        </esg-base-dashboard-card>
      </b-col>
    </b-row>
    <!-- /Scope 3 분기별 배출량 -->

    <!-- Scope 3 배출량 상세 정보 -->
    <b-row>
      <b-col>
        <esg-base-dashboard-card title="Scope 3 배출량 상세">
          <b-container fluid
                       class="mt-3">
            <b-row>
              <!-- Scope 3 배출량 파이 그래프 -->
              <b-col lg="6">
                <div class="title">온실가스 배출량</div>
                <scope-three-emission :color="colors[2]"/>
              </b-col>
              <!-- /Scope 3 배출량 파이 차트 -->

              <!-- Scope 3 카테고리별 배출량 막대 그래프 -->
              <b-col lg="6">
                <div class="d-flex flex-column">
                  <span class="title">온실가스 배출량 비율</span>
                  <span class="subtitle align-middle">(Category 단위)</span>
                </div>
                <scope-three-emission-by-category :colors="colors15"/>
              </b-col>
              <!-- /Scope 3 카테고리별 배출량 막대 그래프 -->
            </b-row>

            <b-row class="mt-3">
              <!-- 업스트림 배출량 -->
              <b-col lg="6">
                <div class="d-flex flex-column">
                  <span class="title mr-1">Upstream 배출량</span>
                  <span class="subtitle align-middle">(Category 1~8)</span>
                </div>
                <scope-three-emission-by-stream type="upstream"
                                                :colors="colors15.slice(0, 8)"/>
              </b-col>
              <!-- /업스트림 배출량 -->

              <!-- 다운스트림 배출량 -->
              <b-col lg="6">
                <div class="d-flex flex-column">
                  <span class="title mr-1">Downstream 배출량</span>
                  <span class="subtitle align-middle">(Category 9~15)</span>
                </div>
                <scope-three-emission-by-stream type="downstream"
                                                :colors="colors15.slice(-7)"/>
              </b-col>
              <!-- /다운스트림 배출량 -->
            </b-row>
          </b-container>
        </esg-base-dashboard-card>
      </b-col>
    </b-row>
    <!-- /Scope 3 배출량 상세 정보 -->
  </esg-base-dashboard>
</template>

<script>
import EsgBaseDashboard from "@/components/esg/base/EsgBaseDashboard.vue";
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";
import EmissionByScopeForThreeYears from "../../charts2/FirmwideEmissionByScopeForThreeYears.vue";
import SingleScopeEmissionForThreeYears from "../../charts2/SingleScopeEmissionForThreeYears.vue";
import SingleScopeMonthlyEmission from "../../charts2/SingleScopeMonthlyEmission.vue";
import SingleScopeQuarterlyEmission from "../../charts2/SingleScopeQuarterlyEmission.vue";
import ScopeThreeEmission from "../../charts2/ScopeThreeEmission.vue";
import ScopeThreeEmissionByCategory from "../../charts2/ScopeThreeEmissionByCategory.vue";
import ScopeThreeEmissionByStream from "../../charts2/ScopeThreeEmissionByStream.vue";
import FirmwideEmissionByScope from "@/components/esg/3. Monitoring/charts2/FirmwideEmissionByScope.vue";

export default {
  components: {
    SingleScopeQuarterlyEmission,
    EsgBaseChart,
    EsgBaseDashboard, EsgBaseDashboardCard,
    FirmwideEmissionByScope,
    EmissionByScopeForThreeYears,
    SingleScopeEmissionForThreeYears,
    SingleScopeMonthlyEmission,
    ScopeThreeEmission,
    ScopeThreeEmissionByCategory,
    ScopeThreeEmissionByStream
  },
  computed: {
    colors() {
      return this.$store.getters['ghg/colors'];
    },
    colors15() {
      return [
        "#FBD308", "#349A6B", "#3F84E5", "#FF4560", "#775DD0",
        "#FEB019", "#9CE2BE", "#008FFB", "#3F51B5", "#546E7A",
        "#D4526E", "#8D5B4C", "#F86624", "#D7263D", "#1B998B",
      ];
    },
  },
}
</script>

<style scoped>
.title {
  font-size: 1rem;
  font-family: NanumGothic, serif;
  font-weight: bold;
  white-space: nowrap;
}

.subtitle {
  font-size: .875rem;
  font-family: NanumGothic, serif;
  font-weight: normal;
  white-space: nowrap;
}
</style>